<template>
    <div>
        <div class="row px-2 py-4" v-if="search.typeFilter == 'FILTER'">
            <div class="col-lg-2">
                <label>รหัสขนส่ง</label>
                <b-input-group>
                    <b-form-input v-model="search.courierKey" placeholder="รหัสขนส่ง"></b-form-input>
                </b-input-group>
            </div>
            <div class="col-lg-3">
                <label>รหัสเรทราคา</label>
                <b-input-group>
                    <b-form-input v-model="search.rateCode" placeholder="รหัสเรทราคา"></b-form-input>
                </b-input-group>
            </div>
            <div class="col-lg-3" v-if="!$USER_LOGIN.get().isSuperadmin">
                <label>ภายใต้ผู้ใช้งาน</label>
                <v-select    
                    label="title"
                    :options="listUnderShop"
                    v-model="search.underShop"
                    :reduce="underShop => underShop.key"
                >
                </v-select>
            </div>
            <div class="col-lg-2" v-if="!disablePackage">
                <label>ระดับแพ็กเกจร้านค้า</label>
                <v-select    
                    label="text"
                    :options="listPackageShop"
                    v-model="search.packageShop"
                    :reduce="packageShop => packageShop.key"
                >
                </v-select>
            </div>
            <div class="col-lg d-flex align-items-end">
                <b-button 
                    variant="primary" 
                    class="m-1"
                    @click="$emit('searchShop')"
                >
                    <i class="fas fa-circle-notch fa-spin" v-if="isLoadSearch"></i>
                    ค้นหา
                </b-button>
            </div>
        </div>
        <div class="row px-2 py-4" v-else>
            <div class="col-12">
                <div class="position-relative">
                    <b-form-textarea
                        v-model="search.shopCode"
                        class="form-control"
                        :placeholder="`${this.$THEME.shopCodePrefix}-000001
${this.$THEME.shopCodePrefix}-000002
${this.$THEME.shopCodePrefix}-000003
${this.$THEME.shopCodePrefix}-000004`"
                        rows="5"
                    ></b-form-textarea>
                    <b-button 
                        variant="primary" 
                        class="btn-textarea m-1"
                        @click="searchShopManagement()"
                    >
                        <i class="fas fa-circle-notch fa-spin" v-if="isLoadSearch"></i>
                        ตกลง
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        search: Object,
        disablePackage: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return{
            listUnderShop:[
                { key: null , title: 'ทั้งหมด'},
                { key: 'SHIPPOP' , title: `${this.$THEME.webTitle}`},
                { key: 'SUPERADMIN' , title: 'SUPERADMIN'},
                { key: 'ALLSUPERADMIN' , title: 'เพิ่มให้เฉพาะ SUPERADMIN', disabled: true },
            ],
            listPackageShop:[
                { key: null , text: 'ทั้งหมด'},
            ],
            isLoadSearch: false
        }
    },
    methods: {
        callPackageTheme () {
            const uri = '/package/theme'
            const header = {
                headers: {
                Token: localStorage.getItem("access_token")
                }
            }
            this.$http.get( this.$API_URL + uri, header).then((res)=> {
                const dataInArray = res.data.data
                dataInArray.map((val) => {
                    this.listPackageShop.push({key: val.id, text: val.name ? val.name : val.key})
                })
            })
        },
        searchShopManagement(){
            this.search.shopCodeArray = this.search.shopCode.split('\n');
            this.$emit('searchShop')
        },
    },
    mounted() {
        this.callPackageTheme()
        this.search.underShop = this.$USER_LOGIN.role =='shippop'?'SHIPPOP':null;
    }
}
</script>